// extracted by mini-css-extract-plugin
export default {"collapsibleBlock":"brand-form_collapsibleBlock__2gw8K"};